





























































import { Vue, Component } from 'vue-property-decorator';
import DemoRequest from '@/components/public/DemoRequest.vue';
import { RouteConfig } from 'vue-router';
import { BRAND_NAME } from '../../common/brand.config';
import { BRAND_LOGIN_PAGE, LOGIN_PAGE } from '../../common/routes.config';

interface NavItem {
  title: string;
  anchor: RouteConfig;
}

@Component({
  components: {
    DemoRequest,
  },
})
export default class Navbar extends Vue {
  drawer: boolean | null = null;

  BRAND_NAME = BRAND_NAME;

  naviationItems: Array<NavItem> = [
    { title: 'Brand Login', anchor: BRAND_LOGIN_PAGE },
    { title: 'Dispensary Login', anchor: LOGIN_PAGE },
  ];
}
